module.exports = __webpack_public_path__ + "static/media/karauti.f86b156e.ogg";